/*!
 * KoliBri - The accessible HTML-Standard
 */
var locale_de = {
    'action-done': 'Aktion abgeschlossen',
    'action-running': 'Aktion wird ausgeführt...',
    'avatar-alt': 'Avatar von {{name}}',
    'character-counter-current': '{{current}} Zeichen',
    'character-counter-current-of-max': '{{current}}/{{max}} Zeichen',
    'character-counter-current-of-max-aria': '{{current}} von {{max}} Zeichen',
    'character-counter-max-aria': 'Zeichenlimit erreicht!',
    'character-limit-exceeded': 'Es sind {{over}} Zeichen zu viel.',
    'character-limit-hint': 'Es können bis zu {{limit}} Zeichen eingegeben werden.',
    'character-limit-remaining': 'Es sind noch {{remaining}} Zeichen verfügbar.',
    'clear-search': 'Suche löschen',
    close: 'Schließen',
    'close-alert': 'Benachrichtigung schließen',
    'data-browse-text': 'Datei auswählen',
    'delete-selection': 'Auswahl entfernen',
    'entries-per-site': 'Einträge pro Seite',
    error: 'Fehler',
    'error-list': 'Fehlerliste',
    'error-list-message': 'Bitte korrigieren Sie folgende Fehler:',
    'filename-text': 'Datei auswählen oder hier ablegen...',
    'form-description': 'Formular-Felder, die mit einem Sternchen (*) gekennzeichnet sind, sind Pflichtangaben.',
    'hide-password': 'ausblenden',
    info: 'Hinweis',
    'kolibri-logo': 'Logo von KoliBri',
    'live-value': '{{value}} {{unit}}',
    'live-value-bounded': '{{value}} von {{max}} {{unit}}',
    message: 'Nachricht',
    'meter-state-critical': 'Kritisch',
    'meter-state-optimum': 'Optimal',
    'meter-state-suboptimal': 'Suboptimal',
    'nav-maximize': 'Navigation maximieren',
    'nav-minimize': 'Navigation minimieren',
    new: 'Neu',
    'no-entries': 'Es sind keine Einträge vorhanden.',
    'no-results-message': 'Keine Ergebnisse gefunden.',
    'open-link-in-tab': 'Öffnet in neuem Tab.',
    page: 'Seite',
    'page-back': 'Eine Seite zurück',
    'page-first': 'Direkt zur ersten Seite',
    'page-last': 'Direkt zur letzten Seite',
    'page-next': 'Eine Seite weiter',
    pagination: 'Paginierung',
    'pagination-position-bottom': 'unten',
    'pagination-position-top': 'oben',
    readonly: 'schreibgeschützt',
    'show-password': 'einblenden',
    sort: 'sortieren',
    'split-button-dropdown-label-open': 'Optionen anzeigen',
    success: 'Erfolg',
    'table-data-loading': 'Daten für Tabelle {{caption}} werden geladen.',
    'table-data-loaded': 'Daten für Tabelle {{caption}} wurden geladen.',
    'table-pagination-label': 'Paginierung für die Tabelle {{label}}',
    'table-selection': 'Auswahl',
    'table-selection-all': 'Alle auswählen',
    'table-selection-indeterminate': 'Alle auswählen bei teilweiser Auswahl',
    'table-selection-none': 'Alle abwählen',
    'table-settings': 'Tabellenkonfiguration',
    'table-settings-apply': 'Übernehmen',
    'table-settings-cancel': 'Abbrechen',
    'table-settings-column-hidable': 'Spalte "{{column}}" ausblenden.',
    'table-settings-column-not-hidable': 'Spalte "{{column}}" kann nicht ausgeblendet werden.',
    'table-settings-column-width': 'Breite von Spalte "{{column}}" in Pixel.',
    'table-settings-error-all-invisible': 'Mindestens eine Spalte muss sichtbar sein.',
    'table-settings-move-down': 'Spalte "{{column}}" nach unten verschieben.',
    'table-settings-move-up': 'Spalte "{{column}}" nach oben verschieben.',
    'table-settings-not-move': 'Spalte "{{column}}" kann nicht verschoben werden.',
    'table-sort-order': 'Priorität {{order}}',
    'table-visible-range': 'Einträge {{start}} bis {{end}} von {{total}}',
    'toast-close-all': 'Alle Benachrichtigungen schließen',
    version: 'Versionsnummer',
    warning: 'Warnung',
};

var locale_en = {
    'action-done': 'Action done',
    'action-running': 'Action is running...',
    'avatar-alt': 'Avatar of {{name}}',
    'character-counter-current': '{{current}} characters',
    'character-counter-current-of-max': '{{current}}/{{max}} characters',
    'character-counter-current-of-max-aria': '{{current}} of {{max}} characters',
    'character-counter-max-aria': 'Character limit reached!',
    'character-limit-exceeded': 'You have {{over}} characters too many.',
    'character-limit-hint': 'You can enter up to {{limit}} characters',
    'character-limit-remaining': 'You have {{remaining}} characters remaining.',
    'clear-search': 'Clear search',
    close: 'Close',
    'close-alert': 'Close notification',
    'data-browse-text': 'Browse',
    'delete-selection': 'Delete selection',
    'entries-per-site': 'Entries per page',
    error: 'Error',
    'error-list': 'Error list',
    'error-list-message': 'Please correct the following errors',
    'filename-text': 'Choose a file or drop it here...',
    'form-description': 'Form fields marked with an asterisk (*) are mandatory.',
    'hide-password': 'Hide',
    info: 'Note',
    'kolibri-logo': 'KoliBri logo',
    'live-value': '{{value}} {{unit}}',
    'live-value-bounded': '{{value}} of {{max}} {{unit}}',
    message: 'Message',
    'meter-state-critical': 'Critical',
    'meter-state-optimum': 'Optimum',
    'meter-state-suboptimal': 'Suboptimal',
    'nav-maximize': 'Maximize navigation',
    'nav-minimize': 'Minimize navigation',
    new: 'New',
    'no-entries': 'No entries available.',
    'no-results-message': 'No results found.',
    'open-link-in-tab': 'Opens in new tab.',
    page: 'Page',
    'page-back': 'One page back',
    'page-first': 'Directly to the first page',
    'page-last': 'Directly to the last page',
    'page-next': 'One page further',
    pagination: 'Pagination',
    'pagination-position-bottom': 'bottom',
    'pagination-position-top': 'top',
    readonly: 'read-only',
    'show-password': 'Show',
    sort: 'sort',
    'split-button-dropdown-label-open': 'Show options',
    success: 'Success',
    'table-data-loading': 'Data in table {{caption}} is loading.',
    'table-data-loaded': 'Data in table {{caption}} got loaded.',
    'table-pagination-label': 'Pagination for table {{label}}',
    'table-selection': 'Selection',
    'table-selection-all': 'Select all',
    'table-selection-indeterminate': 'Select all with partial selection',
    'table-selection-none': 'Deselect all',
    'table-settings': 'Table configuration',
    'table-settings-apply': 'Apply',
    'table-settings-cancel': 'Cancel',
    'table-settings-column-hidable': 'Hide column "{{column}}".',
    'table-settings-column-not-hidable': 'Column "{{column}}" cannot be hidden.',
    'table-settings-column-width': 'Width of column "{{column}}" in pixel.',
    'table-settings-error-all-invisible': 'At least one column must be visible.',
    'table-settings-move-down': 'Move column "{{column}}" down.',
    'table-settings-move-up': 'Move column "{{column}}" up.',
    'table-settings-not-move': 'Column "{{column}}" cannot be moved.',
    'table-sort-order': 'Priority {{order}}',
    'table-visible-range': 'Entries {{start}} to {{end}} of {{total}}',
    'toast-close-all': 'Close all notifications',
    version: 'Version number',
    warning: 'Warning',
};

const mapLocaleKeys = (locale) => Object.keys(locale).reduce((a, c) => ((a[`${'kol'}-${c}`] = locale[c]), a), {});
const TRANSLATIONS = new Set([
    (t) => t('en', mapLocaleKeys(locale_en)),
    (t) => t('de', mapLocaleKeys(locale_de)),
]);
const replaceAll = function (text, search, replacement) {
    return text.split(search).join(replacement);
};
class I18nService {
    constructor(initialLanguage) {
        this.resourceMap = new Map();
        this.language = initialLanguage !== null && initialLanguage !== void 0 ? initialLanguage : 'de';
    }
    addTranslations(translations) {
        if (Array.isArray(translations)) {
            translations = new Set(translations);
        }
        else if (typeof translations === 'function') {
            translations = new Set([translations]);
        }
        if (translations !== undefined) {
            translations.forEach((t) => t((l, t) => {
                let resources = this.resourceMap.get(l);
                if (!resources) {
                    resources = new Map();
                    this.resourceMap.set(l, resources);
                }
                Object.entries(t).forEach(([k, v]) => {
                    if (v) {
                        resources.set(k, v);
                    }
                });
                return l;
            }));
        }
    }
    setLanguage(lng) {
        this.language = lng;
    }
    translate(key, options) {
        var _a;
        let result = (_a = this.resourceMap.get(this.language)) === null || _a === void 0 ? void 0 : _a.get(key);
        if (result) {
            if (options === null || options === void 0 ? void 0 : options.placeholders) {
                Object.entries(options.placeholders).forEach(([k, v]) => {
                    result = replaceAll(result, `{{${k}}}`, v);
                });
            }
        }
        else {
            result = key;
        }
        return result;
    }
}
let i18n;
const getI18nInstance = () => {
    return i18n;
};
const initializeI18n = (lng, translations = TRANSLATIONS) => {
    i18n = new I18nService(lng);
    i18n.addTranslations(translations);
    return i18n;
};

export { getI18nInstance as g, initializeI18n as i };
//# sourceMappingURL=i18n-C73LqPIs.js.map

//# sourceMappingURL=i18n-C73LqPIs.js.map